/**
 * Bounty submission API client wrapping the backend
 * /bounties/:bountyId/submissions/* endpoints. Handles creating and deleting
 * submissions, AI validate/reject actions, copying submission image URLs to
 * S3, and fetching a submission's product URL.
 * Consumed by the SubmissionCreate and SubmissionDisplay pages.
 */
import { api } from "@/lib/axios";
import { SubmissionCreate } from "@/types/submission";

const BountySubmissionAPI = {
    createSubmission: async (bountyId: number, submission: SubmissionCreate) => {
        const { data } = await api.post<{ submission: SubmissionCreate }>(
            `/bounties/${bountyId}/submissions`,
            { submission }
        );
        return data;
    },
    // We're no longer uploading images to the submission, will use image urls instead
    // uploadImages: async (bountyId: number, submissionId: number, formData: FormData) => {
    //     const { data } = await api.post(
    //         `/bounties/${bountyId}/submissions/${submissionId}/upload-images`,
    //         formData,
    //         {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //             },
    //         }
    //     );
    //     return data;
    // },
    aiValidateSubmission: async (bountyId: number, submissionId: number) => {
        const { data } = await api.post(
            `/bounties/${bountyId}/submissions/${submissionId}/ai-validate`
        );
        return data;
    },
    aiRejectSubmission: async (bountyId: number, submissionId: number) => {
        const { data } = await api.post(
            `/bounties/${bountyId}/submissions/${submissionId}/ai-reject`
        );
        return data;
    },
    deleteSubmission: async (bountyId: number, submissionId: number) => {
        const { data } = await api.delete(`/bounties/${bountyId}/submissions/${submissionId}`);
        return data;
    },
    uploadImageUrlsToS3: async (bountyId: number, submissionId: number) => {
        const { data } = await api.post(
            `/bounties/${bountyId}/submissions/${submissionId}/upload-image-urls-to-s3`
        );
        return data;
    },
    getProductUrl: async (bountyId: number, submissionId: number) => {
        const { data } = await api.get<{ productUrl: string }>(
            `/bounties/${bountyId}/submissions/${submissionId}/product-url`
        );
        return data.productUrl;
    },
};

export default BountySubmissionAPI;
